/**
 * Task status enumeration.
 * Must match backend TaskStatus enum.
 */
export enum TaskStatus {
  TODO = 'TODO',
  IN_PROGRESS = 'IN_PROGRESS',
  DONE = 'DONE'
}

export enum TaskPriority {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  URGENT = 'URGENT'
}

export interface TaskComment {
  id: number;
  text: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface TaskChecklistItem {
  id?: number;
  text: string;
  done: boolean;
}

export interface TaskAttachment {
  id: number;
  fileName: string;
  contentType?: string;
  fileSizeBytes: number;
  uploadedAt?: string;
}

/**
 * Task interface representing a task in the system.
 */
export interface Task {
  id?: number;
  title: string;
  description?: string;
  status: TaskStatus;
  priority?: TaskPriority;
  dueDate?: string; // ISO 8601 date string
  sortOrder?: number;
  labels?: string[];
  checklistItems?: TaskChecklistItem[];
  comments?: TaskComment[];
  attachments?: TaskAttachment[];
  createdAt?: string;
  updatedAt?: string;
}

/**
 * Task summary statistics.
 */
export interface TaskSummary {
  totalTasks: number;
  todoTasks: number;
  inProgressTasks: number;
  doneTasks: number;
}

/**
 * Paginated response structure.
 * Matches Spring Boot Page response format.
 */
export interface PagedResponse<T> {
  content: T[];
  currentPage: number;
  totalElements: number;  // Spring Boot uses totalElements
  totalPages: number;
  pageSize: number;
}

/**
 * Error response from API.
 */
export interface ApiError {
  timestamp: string;
  status: number;
  error: string;
  message: string;
  path: string;
  fieldErrors?: Record<string, string>;
}
